require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/settings.template.html');
var i18n = require("l10n");
var popup = require("popup");

var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	Model : null,
	userData: null,
    numberPrivilegeLevel: null,
	initialize: function (options) {
		self = this;

		this.userData = options.data;
		this.numberPrivilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

        this.render();

	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();

		this.$el.html(this.template( {privilegeLevel: this.numberPrivilegeLevel}));
	},
	events:{
		"click #reloadQueueMonitors": "reloadQueueMonitors",
		"click #playText": "playText"
	},
	reloadQueueMonitors: function(event) {
        var self = this;

        var element = $(event.currentTarget);

        var params = {
            "url": "rest/api/settings/reloadQueueMonitors",
            "type": "POST",
            "data": null,
            "successMessage": i18n.t("settings.queueMonitors.reloaded"),
            "errorMessage": i18n.t("settinxxgs.queueMonitors.notReloaded"),
            "_cancelBtn": $('#cancelBtn'),
            "_actionButton": $('#reloadQueueMonitors'),
        }

        popup.show(i18n.t("pageHeader.confirm_action"), i18n.t("settings.queueMonitors.reloadMessage"), "confirm_action", params );
    },
    playText: function() {
        var $elem = $("#textToPlay");

        if(!$elem.val() || $elem.val().length == 0) {
            alert('empty text');
            return;
        }

        //var audioElement = document.createElement('audio');

        var $audio = $("#textToSpeechAudio");
        audioElement = $audio[0];

        // reset it
        audioElement.currentTime = 0;
        audioElement.pause();

        audioElement.setAttribute('src', `rest/call/textToSpeech?text=${encodeURIComponent($elem.val())}`);

        /*audioElement.addEventListener('ended', function() {
            audioElement.play();
        }, false);*/

        audioElement.load();
        audioElement.play();

        audioElement.addEventListener("canplay",function(){
            console.log("Duration:" + audioElement.duration + " seconds");
            console.log("Source:" + audioElement.src);
            console.log("Status: Ready to play");
        });

        //audioElement.play();
        /*$('#play').click(function() {
            audioElement.play();
            $("#status").text("Status: Playing");
        });

        $('#pause').click(function() {
            audioElement.pause();
            $("#status").text("Status: Paused");
        });

        $('#restart').click(function() {
            audioElement.currentTime = 0;
        });*/


    }
});

module.exports = TheView;